var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGps = function SvgGps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.434 4c.421.021.677.415.52.828-.293.777-.594 1.552-.892 2.328L13.303 19.54c-.185.482-.689.613-.996.256a.686.686 0 0 1-.14-.283c-.53-2.277-1.056-4.554-1.578-6.833-.035-.157-.1-.23-.263-.267-2.268-.51-4.534-1.026-6.8-1.542-.322-.073-.51-.273-.525-.548-.014-.273.137-.478.443-.595l14.685-5.64c.098-.037.203-.06.305-.089Z",
    fill: "#333"
  })));
};

export default SvgGps;